var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListadoEvento',{attrs:{"event":_vm.event}},[_c('div',{staticClass:"actions d-flex justify-content-center justify-content-lg-end"},[_c('BotonesCompra',{attrs:{"event":_vm.event,"productos":_vm.productos},on:{"recargar":_vm.recargarEventos}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }